module.exports = __webpack_public_path__ + "static/media/Premium 3.e7d5780b.svg";